export default "__VITE_ASSET__622a47a9__"